import { css, styled } from '@mui/material'

export const PinBox = styled('div', {
  shouldForwardProp: (prop) => prop !== 'error' && prop !== 'selected',
})<{
  error?: boolean
  selected?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.spacing(5)};
  width: ${({ theme }) => theme.spacing(5)};
  border: ${({ theme }) => `${theme.spacing(0.125)} solid ${theme.palette.grey[400]}`};
  border-radius: ${({ theme }) => theme.spacing(1)};

  ${({ error, selected, theme }) =>
    !selected &&
    !error &&
    css`
      margin: ${theme.spacing(0.125)};
    `};

  ${({ selected, theme }) =>
    selected &&
    css`
      border: ${theme.spacing(0.25)} solid ${theme.palette.secondary.main};
    `};

  ${({ error, theme }) =>
    error &&
    css`
      border: ${theme.spacing(0.25)} solid ${theme.palette.error.main};
    `};
`
